var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"user-photo",style:(_vm.imgStyle)},[(!_vm.photo)?_c('i',{staticClass:"fa-regular fa-user",style:(_vm.iconStyle)}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }